import { ReportCommentWithName } from '@helloself/hello-self-ui';
import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { PartnerReportData } from '../../../api/report/types';
import { RequestStatusWithDetails } from '../../../types/RequestStatusWithDetails';
import addReportComment from './asyncReducers/addReportComment';
import loadReport from './asyncReducers/loadReport';

export type ReportId = number;
export type PartnerReportDataWithoutComments = Omit<PartnerReportData, 'reportComments'>;

export type ReportsSlice = {
    memberReports: Record<ReportId, RequestStatusWithDetails<PartnerReportDataWithoutComments>>;
    reportComments: Record<ReportId, RequestStatusWithDetails<ReportCommentWithName[]>>;
};

export const initialState: ReportsSlice = {
    memberReports: {},
    reportComments: {},
};

export const reportsSlice = createSlice({
    name: 'repors',
    initialState,
    reducers: {},
    extraReducers: (builder: ActionReducerMapBuilder<ReportsSlice>) => {
        loadReport(builder);
        addReportComment(builder);
    },
});

export default reportsSlice.reducer;
